import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  List,
  ListItem,
  IconButton,
  useTheme,
} from "@mui/material";
import {
  Facebook,
  LinkedIn,
  X,
} from "@mui/icons-material";
import { Link } from "react-router-dom";

const socialLinks = [
  { icon: <Facebook />, url: "https://web.facebook.com/SiriusTeamEG/" },
  { icon: <LinkedIn />, url: "https://www.linkedin.com/in/siriusTeamEG/" },
  { icon: <X />, url: "https://x.com/SiriusTeamEG" },
];

const navLinks1 = ["Services", "About Us"];
const navLinks2 = ["Posts", "Contacts"];
const navLinks3 = ["FAQ", "Team"];
const linkherf1 = ["about"];
const linkherf2 = ["posts", "contacts"];
const linkherf3 = ["FAQ",'Team'];

const Footer = () => {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      paddingTop={"3rem"}
      bgcolor={theme.palette.mode === "light" ? "whitesmoke" : "#242424"}
      sx={{
        color: theme.palette.mode === "light" ? "black" : "white",
        textAlign: { xs: "center", md: "left" },
      }}
    >
      <Container>
        <Grid container spacing={4} justifyContent="space-between">
          <Grid item xs={12} md={4}>
            <Box mb={4}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  color: theme.palette.mode === "light" ? "#e84545" : "#e84545",
                }}
              >
                SIRIUS
              </Typography>
              <Typography variant="body2">
                At SIRIUS, we believe in the power of technology to
                revolutionize industries. Our team consists of skilled
                professionals with diverse backgrounds in web development.
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={4} sx={{ margin: { xs: "auto", md: null } }}>
            <Grid container spacing={3}>
              <Grid item xs={4} sm={4} md={4} sx={{ textAlign: "center" }}>
                <List>
                  {navLinks1.map((link, index) => (
                    <ListItem key={index}>
                      <Link
                        to={`/${linkherf1[0]}`}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {link}
                      </Link>
                    </ListItem>
                  ))}
                </List>
              </Grid>

              <Grid item xs={4} sm={4} md={4}>
                <Box mb={4}>
                  <List>
                    {navLinks2.map((link, index) => (
                      <ListItem key={index}>
                        <Link
                          to={`/${linkherf2[index]}`}
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          {link}
                        </Link>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Grid>

              <Grid item xs={4} sm={4} md={4}>
                <Box mb={4}>
                  <List>
                    {navLinks3.map((link, index) => (
                      <ListItem key={index}>
                        <Link
                          to={`/${linkherf3[index]}`}
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          {link}
                        </Link>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
            sx={{ textAlign: { xs: "center", md: "right" } }}
          >
            <Box mb={4}>
              <Typography
                variant="h6"
                style={{ textAlign: "center", color: "#e84545" }}
              >
                Follow us
              </Typography>
              <List
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "center" },
                  textAlign: "center",
                }}
              >
                {socialLinks.map((link, index) => (
                  <ListItem key={index} sx={{ padding: 0,display:"flex",justifyContent:'center' }}>
                    <IconButton href={link.url} color="inherit">
                      {link.icon}
                    </IconButton>
                  </ListItem>
                ))}
              </List>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Typography
        variant="body2"
        align="center"
        sx={{
          padding: "1rem 0",
          borderTop: `1px solid ${
            theme.palette.mode === "light" ? "#ccc4c4" : "#e84545"
          }`,
        }}
      >
        Policy Privacy © 2024 SIRIUS All Rights Reserved
      </Typography>
    </Box>
  );
};

export default Footer;
